import {NgModule} from '@angular/core';
import {KeeniconComponent} from './keenicon/keenicon.component';
import {CommonModule} from "@angular/common";
import {SkeletonModule} from "primeng/skeleton";

@NgModule({
  declarations: [
    KeeniconComponent
  ],
  imports: [
    CommonModule,
    SkeletonModule
  ],
  exports: [
    KeeniconComponent,
    SkeletonModule
  ]
})
export class SharedModule {
}
